import React, { useState, setState, useReducer } from "react";
import "./influencerSearch.css";
import Chat from "../images/chat.svg";
import homeIcon from "../images/home.svg";
import person from "../images/person.svg";
import search from "../images/search.svg";
import Card from "./card";
import background1 from "../images/back.jpg";
import profile1 from "../images/45.png";
import Users from "./influencers.json";
import Navbar from "./navBar"
import Interra from "../images/logo.png";
import NavbarInfluencer from "./NavbarInfluencer";

function Influencer() {
  return (
    <div className="outer1">
     
      <img src={Interra} className="logo4"></img>
      <button className='logout2'>Logout</button>
      {/* <div className="inner1">
      <a href="/" className='H-txt'> <img src='/images/home.png' className="b1-icon1" alt='home'></img></a>
      <a href="/infsearch" className='H-txt'><img src='/images/search-coloured.png' className="b1-icon2" alt='search'></img></a>
      <a href="/chat" className='H-txt'> <img src='/images/message.png' className="b1-icon3" alt='message'></img></a>
      <a href="/influencer-details" className='H-txt'> <img src='/images/profile-coloured.png' className="b1-icon4" alt='person'></img></a> 
      </div> */}
      <Navbar/>
      <div className="main">
        {/* <div className="searchbar"> */}
        <img src={search} className="sear"></img>
        <input
          type="text"
          id="header-search"
          placeholder="Search Influencers"
          name="s"
          className="search"
        />
        {/* </div> */}
      </div>

      <div className="row4">

        {Users.map((user) => (
          <div className="cols1">
            <Card key={user.id} Name={user.name}
              Image={user.background}
              Age={user.age}
              Gender={user.gender}
              Location={user.location}
              Followers={user.follower}
              Tags={user.tags}
              Profile={user.pic} />
          </div>
        ))}
      </div>

      <div className="row5">

        {Users.map((user) => (
          <div className="cols1">
            <Card key={user.id} Name={user.name}
              Image={user.background}
              Age={user.age}
              Gender={user.gender}
              Location={user.location}
              Followers={user.follower}
              Tags={user.tags}
              Profile={user.pic} />
          </div>
        ))}
      </div>
    </div>

  );
}

export default Influencer;
